import { useCallback, useState } from 'react';

const STORAGE_KEY = 'translator.visibleLocales';

const readFromStorage = (): Set<string> => {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (raw === null) return new Set();
  try {
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.filter((x): x is string => typeof x === 'string'));
  } catch {
    return new Set();
  }
};

/**
 * baseLocale 以外で表示中の locale を localStorage に保存して全グループで共有する。
 * 初回は空 Set (= baseLocale だけ表示) で、ユーザーが必要な言語を足していく。
 */
export const useVisibleLocales = (): {
  visible: Set<string>;
  toggle: (locale: string) => void;
} => {
  const [visible, setVisible] = useState<Set<string>>(readFromStorage);

  const toggle = useCallback((locale: string) => {
    setVisible((prev) => {
      const next = new Set(prev);
      if (next.has(locale)) next.delete(locale);
      else next.add(locale);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(next)));
      return next;
    });
  }, []);

  return { visible, toggle };
};
